module.exports = __webpack_public_path__ + "static/img/chanping7.67f8837.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img1/nxyp/chanping7.jpg
// module id = qOch
// module chunks = 0